<div (click)="openDebug()" class="open-debug" #insideElement></div>

<ng-template #dialogue>
  <div mat-dialog-content>
    <p>Input task ID...</p>
    <mat-form-field>
      <mat-label>ID</mat-label>
      <input matInput [(ngModel)]="task" type="number">
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button (click)="onOkClick()">Ок</button>
  </div>
</ng-template>